module.exports = __webpack_public_path__ + "img/reminder.4c48312f.png";